import React from 'react';
import { AlertTriangle, CheckCircle, Undo2 } from 'lucide-react';

// requested_by is the admin who submitted the request via Add Leave.
export function isOwnLeaveRequest(user, leave) {
  if (!user?.id) return false;
  return leave?.user_id === user.id || leave?.requested_by === user.id;
}

export function canRevokeApprovedLeave(user, leave) {
  return user?.role === 'admin' && leave?.status === 'approved' && !isOwnLeaveRequest(user, leave);
}

const LeaveDecisionActions = ({
  leave,
  canApprove,
  canRevoke,
  onApprove,
  onDecline,
  onRevoke,
  compact = false,
}) => {
  if (!canApprove && !canRevoke) {
    if (!compact) return null;
    return <span className="text-sm text-secondary-500 italic">—</span>;
  }

  const wrapClass = compact
    ? 'flex items-center gap-2'
    : 'flex flex-wrap gap-2 pt-1';
  const btnPad = compact ? 'px-2.5 py-1.5' : 'px-3 py-2 min-h-[44px]';

  return (
    <div className={wrapClass}>
      {canApprove && (
        <>
          <button
            type="button"
            onClick={() => onApprove(leave)}
            className={`inline-flex items-center gap-1 ${btnPad} text-xs font-medium rounded-md text-green-700 bg-green-50 hover:bg-green-100 transition-colors`}
            title="Approve leave request"
          >
            <CheckCircle className="h-3.5 w-3.5" />
            Approve
          </button>
          <button
            type="button"
            onClick={() => onDecline(leave)}
            className={`inline-flex items-center gap-1 ${btnPad} text-xs font-medium rounded-md text-red-700 bg-red-50 hover:bg-red-100 transition-colors`}
            title="Decline leave request"
          >
            <AlertTriangle className="h-3.5 w-3.5" />
            Decline
          </button>
        </>
      )}
      {canRevoke && (
        <button
          type="button"
          onClick={() => onRevoke(leave)}
          className={`inline-flex items-center gap-1 ${btnPad} text-xs font-medium rounded-md text-amber-800 bg-amber-50 hover:bg-amber-100 transition-colors`}
          title="Revoke this approved leave"
        >
          <Undo2 className="h-3.5 w-3.5" />
          Revoke
        </button>
      )}
    </div>
  );
};

export default LeaveDecisionActions;
